import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RouteGuard } from './shared/guard/route.guard';

import { EntitiesComponent } from './entities/entities.component';

const routes: Routes = [
  { path: 'agreement-viewer/:referenceCode', loadChildren: () => import('./pages/agreement-viewer/agreement-viewer.module').then(mod => mod.AgreementViewerModule) },
  { path: 'callback-auth', loadChildren: () => import('./pages/login/login.module').then(mod => mod.LoginModule) },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(mod => mod.LoginModule) },
  { path: 'siuu', loadChildren: () => import('./pages/login2/login.module').then(mod => mod.LoginModule2) },
  {
    path: '',
    component: EntitiesComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./entities/dashboard/dashboard.module').then(mod => mod.DashboardModule),
        canActivate: [RouteGuard],
        canActivateChild: [RouteGuard]
      },
      {
        path: 'common',
        loadChildren: () => import('./entities/common/common.module').then(mod => mod.CommonModule),
        canActivate: [RouteGuard],
        canActivateChild: [RouteGuard]
      },
      {
        path: 'customer',
        loadChildren: () => import('./entities/customer/customer.module').then(mod => mod.CustomerModule),
        canActivate: [RouteGuard],
        canActivateChild: [RouteGuard]
      },
      {
        path: 'manager',
        loadChildren: () => import('./entities/manager/manager.module').then(mod => mod.ManagerModule),
        canActivate: [RouteGuard],
        canActivateChild: [RouteGuard]
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
